import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Greeting message ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Ban timeout (minutes) ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Ban for emoji count in message, greater or equal of this value ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("URL Protection")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Question protection")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Questions ")
const _hoisted_11 = { class: "question" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Question ")
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Answer ")
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Correct ")
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Domains for ignore (i.e. github.com)", -1)
const _hoisted_22 = { class: "question" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.expired)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Token expired"))
      : _createCommentVNode("", true),
    (_ctx.ttl)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Access to this page with requested token granted due to " + _toDisplayString(_ctx.date()), 1))
      : _createCommentVNode("", true),
    (!_ctx.group)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
      : _createCommentVNode("", true),
    (_ctx.group)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("form", null, [
            _createElementVNode("p", null, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.group.greeting) = $event))
              }, null, 512), [
                [_vModelText, _ctx.group.greeting]
              ])
            ]),
            _createElementVNode("p", null, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.group.ban_timeout) = $event))
              }, null, 512), [
                [_vModelText, _ctx.group.ban_timeout]
              ])
            ]),
            _createElementVNode("p", null, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.group.ban_emojii_count) = $event))
              }, null, 512), [
                [_vModelText, _ctx.group.ban_emojii_count]
              ])
            ]),
            _createElementVNode("p", null, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.group.ban_url) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.group.ban_url]
              ])
            ]),
            _createElementVNode("p", null, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.group.ban_question) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.group.ban_question]
              ])
            ]),
            _createElementVNode("p", null, [
              _hoisted_10,
              _createElementVNode("input", {
                type: "button",
                value: "Add new question",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addQuestion && _ctx.addQuestion(...args)))
              })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.questions, (question, questionIndex) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("input", {
                  type: "button",
                  value: "Delete this question",
                  onClick: ($event: any) => (_ctx.deleteQuestion(questionIndex))
                }, null, 8, _hoisted_12),
                _createElementVNode("p", null, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((question.text) = $event)
                  }, null, 8, _hoisted_14), [
                    [_vModelText, question.text]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, answerIndex) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    _createElementVNode("p", null, [
                      _hoisted_15,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((answer.text) = $event)
                      }, null, 8, _hoisted_16), [
                        [_vModelText, answer.text]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((answer.correct) = $event)
                      }, null, 8, _hoisted_17), [
                        [_vModelCheckbox, answer.correct]
                      ]),
                      _hoisted_18,
                      _createElementVNode("input", {
                        type: "button",
                        value: "Delete answer",
                        onClick: ($event: any) => (_ctx.deleteAnswer(questionIndex, answerIndex))
                      }, null, 8, _hoisted_19)
                    ])
                  ]))
                }), 256)),
                _createElementVNode("input", {
                  type: "button",
                  value: "Add new answer",
                  onClick: ($event: any) => (_ctx.addAnswer(questionIndex))
                }, null, 8, _hoisted_20)
              ]))
            }), 256)),
            _hoisted_21,
            _createElementVNode("input", {
              type: "button",
              value: "Add domain",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addDomain && _ctx.addDomain(...args)))
            }),
            _createElementVNode("input", {
              type: "button",
              value: "Add default domains list (github, pastebin and so on)",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addDefaultDomains && _ctx.addDefaultDomains(...args)))
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.ignore_domains, (domain, idx) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("p", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((_ctx.group.ignore_domains[idx]) = $event)
                  }, null, 8, _hoisted_23), [
                    [_vModelText, _ctx.group.ignore_domains[idx]]
                  ]),
                  _createElementVNode("input", {
                    type: "button",
                    value: "Delete",
                    onClick: ($event: any) => (_ctx.deleteDomain(idx))
                  }, null, 8, _hoisted_24)
                ])
              ]))
            }), 256)),
            _hoisted_25,
            _hoisted_26,
            _createElementVNode("input", {
              type: "submit",
              value: "Save",
              disabled: _ctx.blocked,
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, null, 8, _hoisted_27),
            (_ctx.saved)
              ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Saved"))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}